import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page play-page" }
const _hoisted_2 = {
  key: 0,
  class: "win-flash"
}
const _hoisted_3 = { class: "top-hud" }
const _hoisted_4 = { class: "skin-selector" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = { class: "skin-icon" }
const _hoisted_7 = { class: "hud-right" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "wallet-bal" }
const _hoisted_10 = { class: "status-row" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "pnl-scope" }
const _hoisted_13 = { class: "pnl-amount mono" }
const _hoisted_14 = {
  key: 0,
  class: "sparkline"
}
const _hoisted_15 = { class: "streak-icon" }
const _hoisted_16 = { class: "control-group amount-slider" }
const _hoisted_17 = { class: "amount-readout" }
const _hoisted_18 = { class: "amount-value" }
const _hoisted_19 = ["min", "max", "disabled"]
const _hoisted_20 = { class: "amount-ends" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "amount-warn"
}
const _hoisted_23 = {
  key: 2,
  class: "amount-warn"
}
const _hoisted_24 = {
  key: 3,
  class: "amount-warn"
}
const _hoisted_25 = {
  key: 4,
  class: "amount-warn"
}
const _hoisted_26 = {
  key: 5,
  class: "amount-warn"
}
const _hoisted_27 = { class: "odds-slider" }
const _hoisted_28 = { class: "odds-readout" }
const _hoisted_29 = { class: "odds-step-label" }
const _hoisted_30 = { class: "odds-stats" }
const _hoisted_31 = { class: "win-pct" }
const _hoisted_32 = { class: "payout-mult" }
const _hoisted_33 = {
  key: 0,
  class: "win-amt"
}
const _hoisted_34 = ["min", "max", "disabled"]
const _hoisted_35 = { class: "auto-selector" }
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "flip-stage-hint"
}
const _hoisted_39 = {
  key: 1,
  class: "hotkey-hint"
}
const _hoisted_40 = { class: "slab-label" }
const _hoisted_41 = { class: "slab-amount mono" }
const _hoisted_42 = {
  class: "hist-modal",
  role: "dialog",
  "aria-label": "Game history"
}
const _hoisted_43 = { class: "hist-header" }
const _hoisted_44 = { class: "hist-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StalledBets = _resolveComponent("StalledBets")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_GameHistoryList = _resolveComponent("GameHistoryList")!
  const _component_GameDetailsModal = _resolveComponent("GameDetailsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.winFlash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skins, (skin) => {
          return (_openBlock(), _createElementBlock("button", {
            key: skin.id,
            class: _normalizeClass(["skin-chip", { selected: _ctx.currentSkinId === skin.id }]),
            title: skin.name,
            onClick: ($event: any) => (_ctx.selectSkin(skin.id))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(skin.icon), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "history-btn",
          title: "Game history",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
        }, "♣"),
        _createVNode(_component_router_link, {
          to: "/how-it-works",
          class: "history-btn help-btn",
          title: "How it works"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("?", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "wallet-chip mono",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-wallet'))),
          title: `Wallet — ${_ctx.arkStatus}`
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["conn-dot", _ctx.arkStatus])
          }, null, 2),
          _cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "wallet-ico",
            "aria-hidden": "true"
          }, "💰", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.walletBalanceLabel), 1)
        ], 8, _hoisted_8)
      ])
    ]),
    _createVNode(_component_StalledBets),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: _normalizeClass(["pnl-pill", _ctx.pnlClass]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePnlScope && _ctx.togglePnlScope(...args))),
        title: `Click to switch — currently ${_ctx.pnlScope}`
      }, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pnlScope), 1),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formattedPnl), 1)
      ], 10, _hoisted_11),
      (_ctx.sparkline.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sparkline, (r, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: r.key,
                class: _normalizeClass(["spark-dot", r.won ? 'win' : 'loss']),
                style: _normalizeStyle({ animationDelay: `${(_ctx.sparkline.length - 1 - i) * 12}ms` })
              }, null, 6))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "streak-pop" }, {
        default: _withCtx(() => [
          (_ctx.streak.count >= 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["streak-badge", _ctx.streak.kind])
              }, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.streak.kind === 'win' ? '🔥' : '❄'), 1),
                _createTextVNode(" STREAK ×" + _toDisplayString(_ctx.streak.count), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["skin-area", { playing: _ctx.isFlipping }])
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentSkin.component), {
        state: _ctx.skinState,
        tier: _ctx.betAmount,
        "odds-edge-bps": _ctx.oddsEdgeBps,
        dust: _ctx.dust,
        onLaunch: _ctx.onSkinLaunch,
        onCashout: _ctx.onSkinCashout
      }, null, 40, ["state", "tier", "odds-edge-bps", "dust", "onLaunch", "onCashout"]))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["controls", { inert: _ctx.isFlipping && !_ctx.isAutoRunning }])
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "amount-label" }, "Bet", -1)),
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_NumberField, {
              "model-value": _ctx.betAmount,
              format: _ctx.formatSats,
              disabled: _ctx.isAutoRunning || !_ctx.canBet,
              "aria-label": "Bet amount in sats",
              onCommit: _ctx.commitAmount
            }, null, 8, ["model-value", "format", "disabled", "onCommit"]),
            _cache[14] || (_cache[14] = _createTextVNode(" sats ", -1))
          ])
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "amount-range",
          type: "range",
          min: _ctx.amountBounds.min,
          max: _ctx.usableMax,
          step: "1",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.betAmount) = $event)),
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rememberAmount && _ctx.rememberAmount(...args))),
          disabled: _ctx.isAutoRunning || !_ctx.canBet,
          "aria-label": "Bet amount"
        }, null, 40, _hoisted_19), [
          [
            _vModelText,
            _ctx.betAmount,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString(_ctx.tiersLoaded ? _ctx.amountBounds.min.toLocaleString() : '—'), 1),
          (!_ctx.tiersLoaded)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Loading bet range…"))
            : (_ctx.lowerOddsWouldHelp)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Lower the win chance — " + _toDisplayString(_ctx.winPctValue) + "% needs " + _toDisplayString(_ctx.amountBounds.min.toLocaleString()) + " sats ", 1))
              : (!_ctx.amountBounds.feasible)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "House can't cover a bet at this win chance"))
                : (!_ctx.canAffordRung)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Balance too low — add funds to bet at " + _toDisplayString(_ctx.winPctValue) + "% ", 1))
                  : (!_ctx.canBet)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "House has no capacity right now"))
                    : (_ctx.balanceCapped)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Capped by your wallet balance"))
                      : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.tiersLoaded && _ctx.canAffordRung ? _ctx.usableMax.toLocaleString() : '—'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.stepLabel), 1),
          _createElementVNode("span", _hoisted_30, [
            _createElementVNode("span", _hoisted_31, [
              _createVNode(_component_NumberField, {
                "model-value": _ctx.winPctValue,
                disabled: _ctx.isAutoRunning,
                "aria-label": "Win chance percent",
                onCommit: _ctx.commitWinPct
              }, null, 8, ["model-value", "disabled", "onCommit"]),
              _cache[16] || (_cache[16] = _createTextVNode("% win ", -1))
            ]),
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.payoutMult(_ctx.selectedBet)), 1),
            (_ctx.canBet)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "→ " + _toDisplayString(_ctx.winSatsLabel(_ctx.selectedBet)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "odds-range",
          type: "range",
          min: _ctx.minStep,
          max: _ctx.maxStep,
          step: "1",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sliderIndex) = $event)),
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.rememberStep && _ctx.rememberStep(...args))),
          disabled: _ctx.isAutoRunning,
          "aria-label": "Odds"
        }, null, 40, _hoisted_34), [
          [
            _vModelText,
            _ctx.sliderIndex,
            void 0,
            { number: true }
          ]
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "odds-ends" }, [
          _createElementVNode("span", null, "safer · bigger chance"),
          _createElementVNode("span", null, "riskier · bigger payout")
        ], -1))
      ]),
      (!_ctx.skinOwnsGesture)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoOptions, (opt) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: opt.label,
                  class: _normalizeClass(["auto-chip", { selected: _ctx.autoCount === opt.value }]),
                  disabled: _ctx.isAutoRunning,
                  onClick: ($event: any) => (_ctx.selectAuto(opt.value))
                }, _toDisplayString(opt.label), 11, _hoisted_36))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["flip-btn", { active: _ctx.canFlip, stop: _ctx.isAutoRunning, stopping: _ctx.stopRequested }]),
              disabled: (!_ctx.canFlip && !_ctx.isAutoRunning) || _ctx.stopRequested,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.doFlip && _ctx.doFlip(...args)))
            }, [
              (_ctx.stopRequested)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("STOPPING AFTER THIS FLIP…")
                  ], 64))
                : (_ctx.isAutoRunning)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("STOP · " + _toDisplayString(_ctx.autoProgressLabel), 1)
                    ], 64))
                  : (_ctx.isAutoMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.isFlipping ? _ctx.flipStageLabel : `AUTO ×${_ctx.autoCountLabel}`), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(_toDisplayString(_ctx.isFlipping ? _ctx.flipStageLabel : 'FLIP IT'), 1)
                      ], 64))
            ], 10, _hoisted_37),
            (_ctx.isFlipping && _ctx.isAutoRunning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", {
                    class: "stage-dot",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.flipStageLabel), 1)
                ]))
              : (!_ctx.isAutoMode && !_ctx.isFlipping && _ctx.canFlip)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Press Enter to flip"))
                : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "error-toast",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.error = null)),
          title: "Tap to dismiss"
        }, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slab" }, {
      default: _withCtx(() => [
        (_ctx.slab)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["result-slab", _ctx.slab.won ? 'win' : 'loss'])
            }, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.slab.won ? 'YOU WIN' : 'YOU LOSE'), 1),
              _createElementVNode("div", _hoisted_41, [
                _createTextVNode(_toDisplayString(_ctx.slab.won ? '+' : '−') + _toDisplayString(Math.abs(_ctx.slab.amount).toLocaleString()) + " ", 1),
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "slab-unit" }, "sats", -1))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "hist-fade" }, {
      default: _withCtx(() => [
        (_ctx.historyOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hist-backdrop",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.historyOpen = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("header", _hoisted_43, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "hist-title" }, "Game History", -1)),
                  _createElementVNode("button", {
                    class: "hist-close",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.historyOpen = false)),
                    "aria-label": "Close"
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_GameHistoryList, {
                    games: _ctx.historyGames,
                    onSelect: _ctx.openDetail
                  }, null, 8, ["games", "onSelect"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_GameDetailsModal, {
      open: _ctx.detailOpen,
      "game-id": _ctx.detailGameId,
      "player-pubkey": _ctx.playerPubkey,
      network: _ctx.networkName,
      onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailOpen = false))
    }, null, 8, ["open", "game-id", "player-pubkey", "network"])
  ]))
}